import {useEffect} from "react";
import {authGet} from "../api/auth/authGet.ts";
import {useOwnProfile} from "../stores/OwnProfileStore.ts";
import {useNavigate} from "react-router";

type Params = {
    redirectOnSuccess?: string;
    redirectOnError?: string;
}

export const useCheckAuth = ({ redirectOnSuccess, redirectOnError }: Params) => {
    const { profile, setProfile } = useOwnProfile();
    const navigate = useNavigate();

    useEffect(() => {
        if(!profile) {
            authGet().then(({ payload }) => {
                if(payload) {
                    setProfile(payload);
                    if(redirectOnSuccess) {
                        navigate(redirectOnSuccess);
                    }
                    return;
                }
                if(redirectOnError) {
                    navigate(redirectOnError);
                }
            }).catch(() => {
                if(redirectOnError) {
                    navigate(redirectOnError);
                }
            });
        }
    }, [profile]);
}